import { Button, FormControl, Grid, makeStyles, Paper, TextField } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import Color from '../../../styles/Color';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';

const styles = makeStyles(theme=>({
    aLink:{
        color: '#707070',
        transition: 'all .15s',
        "&:hover":{
            color: Color.primary,
            textDecoration: 'underline !important',
        }
    },
    inputControl:{
        '& .MuiFormHelperText-root':{
            position: 'absolute',
            left: 0,
            bottom: -23,
        }
    },
    imageLeft:{
        maxWidth:'100%',
        height:'auto',
        objectFit:'cover',
        textAlign:'center',
    }
}));

const validateYupSchema = yup.object({
    email: yup.string().email("Invalid email format.").required("Required.")
});

//  ==================== function main ====================
export default function ForgetPassword() {
    const classes = styles();
    // config formik
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: validateYupSchema,
        onSubmit: (values)=>{
            alert(values)
        }
    })
    return (
        <div className="d-flex flex-column flex-root">
            <div 
            className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
            id="kt_login"
            style={{background: 'linear-gradient(to right, rgb(255, 255, 255), rgb(228, 245, 253), rgb(173, 224, 249))'}}>
                <div className='d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden'>
                    <Grid container spacing={3} className="h-100">
                        {/* Image at left */}
                        <Grid item xs={12} md={5} lg={5} className='d-none d-lg-flex'>
                            <div className='h-100 d-flex align-items-center justify-content-cneter'>
                                <img src={toAbsoluteUrl('/media/HCH/imgs/forgetpass.png')} alt='forgetpass.png' className={classes.imageLeft} />
                            </div>
                        </Grid>

                        {/* Form at right */}
                        <Grid item xs={12} md={7} lg={7} className='d-flex align-items-center justify-content-center'>
                            <Paper className='px-5 px-lg-15 py-20 w-lg-700px d-flex align-items-center justify-content-center' style={{maxWidth:'100%'}}>
                                {/* start form */}
                                <form onSubmit={formik.handleSubmit}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <h2 className='t-text-primary mb-5'>Reset your password</h2>
                                            <h6 className='text-muted'>
                                                Reset password will be sent to the mailbox. <br/>
                                                Please check it.
                                            </h6>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl className="t-form-group-custom w-100 mb-5" >
                                                {/* <FormLabel className='text-dark mb-4'>Email</FormLabel> */}
                                                <TextField
                                                    label='Email'
                                                    type={'email'}
                                                    name="email"
                                                    fullWidth
                                                    variant="outlined"
                                                    className={classes.inputControl}
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                                    helperText={formik.touched.email && (formik.errors.email)}
                                                />
                                            </FormControl>
                                        </Grid>
                                        {/* actions */}
                                        <Grid item xs={12}>
                                            <div className='row justify-content-md-between align-items-center'>
                                                <div className='col-12 col-md-4 col-lg-3 order-2'>
                                                    <Link to={'/auth/login'} className={classes.aLink}>Back to login</Link>
                                                </div>
                                                <div className='col-12 col-md-4 col-lg-3 mb-5 mb-lg-0 order-1 order-md-2'>
                                                    <Button type="submit" size="large" className='btn t-btn-primary w-100'>
                                                        SEND
                                                    </Button>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </form>
                                {/* end form */}
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
}
